<template>
  <div
    @dragover="dragover"
    @dragleave="dragleave"
    @drop="drop"
    @click="$refs.inputFile.click()"
    class="upload-document-wrapper"
  >
    <input class="d-none" ref="inputFile" type="file" @change="change" />

    <div class="d-flex align-items-center justify-content-center h-100">
      <span class="mod-icon-upload" />
      <span class="upload-title">
        <template v-if="!addingFile">
          Browse or drag to upload
        </template>
        <template v-else>
          {{ progress }}%
        </template>
      </span>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import Errors from '../../../classes/Errors';

export default {
  name: 'UploadDocument',
  props: {
    label: { type: String, default: 'Browse' },
    src: { type: Object, default: null },
    styleClass: { type: String, default: 'square-upload ' },
    typeId: { type: Number, default: null },
    model: { type: String, default: 'jobs' },
    modelId: { type: Number, default: null },
    recommended: { type: String, default: '' },
  },
  data() {
    return {
      addingFile: false,
      error: '',
      errors: new Errors(),
      progress: 0,
    };
  },
  methods: {
    dragover(e) {
      e.preventDefault();
    },
    dragleave() {},
    drop(e) {
      e.preventDefault();
      if (e.dataTransfer.files[0]) {
        const file = e.dataTransfer.files[0];
        this.uploadFile(file);
      }
    },
    change(e) {
      const file = e.target.files[0];
      this.uploadFile(file);
    },
    uploadFile(file) {
      this.addingFile = true;
      const config = {
        onUploadProgress: progressEvent => {
          this.progress = (100 * progressEvent.loaded) / progressEvent.total;
        },
      };
      const form = new FormData();
      form.append('file', file);
      axios
        .post(`/${this.model}/${this.modelId}/files`, form, config)
        .then(() => {
          this.$emit('uploaded');
          toastr.success('Successfully uploaded document.');
        })
        .catch(err => {
          if (err.response.data.error && err.response.data.error.file) {
            toastr.error(err.response.data.error.file);
          } else {
            toastr.error('Server error, please try again!');
          }
        })
        .finally(() => {
          this.addingFile = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.upload-document-wrapper {
  background-color: #f3f6fa;
  border: 2px dashed #eeeeee;
  margin-right: 10px;
  width: 200px;
  height: 70px;

  .dropzone {
    background-color: unset !important;
  }

  .h-100 {
    height: 70px !important;
  }

  .upload-title {
    color: #8e8e92;
    font-weight: bold;
    margin-left: 5px;
    text-decoration: underline;
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/subcomponents/UploadDocument.vue